/* Waxman's Gym Ratio Calculator Copyright (C) 2017 Waxman's Gym

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU General Public License for more details.

You should have received a copy of the GNU General Public License
along with this program.  If not, see <http://www.gnu.org/licenses/>.*/

import React from 'react';

let ranges = {
    ideal: 2.5,
    acceptable: 5,
    unacceptable: 7.5,
}

const accessories = {
    snatch: {
        'Overhead Squat': { ratio: 105, display: (<span>Overhead <br className="hidden-sm hidden-xs" />Squat</span>) },
        'Power Snatch': { ratio: 80, display: (<span>Power <br className="hidden-sm hidden-xs" />Snatch</span>) },
        'Snatch Blocks Abv Knee': { ratio: 95, display: (<span>Snatch Blocks <br className="hidden-sm hidden-xs" />Abv Knee</span>) },
        'Hang Snatch Below Knee': { ratio: 95, display: (<span>Hang Snatch <br className="hidden-sm hidden-xs" />Below Knee</span>) }
    },
    cnj: {
        'Clean': { ratio: 102, display: (<span>Clean</span>) },
        'Back Squat': { ratio: 135, display: (<span>Back <br className="hidden-sm hidden-xs" />Squat</span>) },
        'Front Squat': { ratio: 115, display: (<span>Front <br className="hidden-sm hidden-xs" />Squat</span>) },
        'Jerk': { ratio: 105, display: (<span>Jerk</span>) },
        'Power Clean': { ratio: 80, display: (<span>Power <br className="hidden-sm hidden-xs" />Clean</span>) },
        'Clean Blocks Abv Knee': { ratio: 95, display: (<span>Clean Blocks <br className="hidden-sm hidden-xs" />Abv Knee</span>) },
        'Hang Clean Below Knee': { ratio: 95, display: (<span>Hang Clean <br className="hidden-sm hidden-xs" />Below Knee</span>) }
    }
};

// Accessory Diagnoses
const diagnoses = {
    'Clean': {
        'too_low': 'Isso é estatisticamente improvável... Se você consegue fazer Clean & Jerk com determinada carga, você deve ser capaz de fazer Clean com a mesma carga, certo? Revise os números inseridos e tente novamente',
        'too_high': 'Parece que há um problema com seu Jerk. Se as suas proporções de squat estão adequadas, você deve ter dificuldade na técnica do Jerk. Se suas proporções de squat estão abaixo do ideal você pode ter um problema de força ou de geração de potência para a execução do Jerk.'
    },
    'Back Squat': {
        'too_low': 'Você pode estar sendo prejudicado por ter pernas fracas. Se você ainda não percebeu essa dificuldade, é possível que você esteja fazendo os movimentos com alto nível de stress nesta região.',
        'too_high': 'Aparentemente você possui força para fazer um Clean & Jerk mais pesado do que está fazendo. O que está lhe impedindo pode ser um fator técnico.'
    },
    'Front Squat': {
        'too_low': 'Você pode estar sendo prejudicado por ter pernas fracas. Se você ainda não percebeu essa dificuldade, é possível que você esteja fazendo os movimentos com alto nível de stress nesta região.',
        'too_high': 'Aparentemente você possui força para fazer um Clean & Jerk mais pesado do que está fazendo. O que está lhe impedindo pode ser um fator técnico.'
    },
    'Jerk': {
        'too_low': 'Se as suas proporções de squat estão adequadas, você deve ter dificuldade na técnica do Jerk. Se suas proporções de squat estão abaixo do ideal você pode ter um problema de força ou de geração de potência para a execução do Jerk.',
        'too_high': 'Assumindo que os seus níveis de força estão adequados, isso nos diz que você pode ter problemas com a eficiência (técnica e/ou geração de potência) no clean.'
    },
    'Power Clean': {
        'too_low': 'Isso nos diz que você possui pernas fracas ou baixa explosão/transmissão de velocidade.',
        'too_high': 'Se o seu from squat está em um nível de proporção adequado, você deve ter uma dificuldade técnica no seu Clean & Jerk. Se o seu Front squat está muito abaixo do adequado você pode ter uma dificuldade de força, mobilidade ou de ambos.'
    },
    'Clean Blocks Abv Knee': {
        'too_low': 'Aparentemente você possui dificuldade com explosão vertical.',
        'too_high': 'Aparentemente você possui dificuldade quando você arranca a barra do solo.'
    },
    'Hang Clean Below Knee': {
        'too_low': 'Você possui pouca força de costas ou falta de coordenação.',
        'too_high': 'Aparentemente você possui dificuldade quando você arranca a barra do solo.'
    },
    'Overhead Squat': {
        'too_low': 'Isso nos diz que voe possui problemas com a estabilização no Overhead.',
        'too_high': 'Mesmo que você consiga fazer Overhead com muita carga, isso não nos diz muito.'
    },
    'Power Snatch': {
        'too_low': 'Isso nos diz que você possui pernas fracas ou baixa explosão/transmissão de velocidade.',
        'too_high': 'Isso nos diz que você está com pouca mobilidade ou coordenação.'
    },
    'Snatch Blocks Abv Knee': {
        'too_low': 'Aparentemente você possui dificuldade com explosão vertical.',
        'too_high': 'Aparentemente você possui dificuldade quando você arranca a barra do solo.'
    },
    'Hang Snatch Below Knee': {
        'too_low': 'Você possui pouca força de costas ou falta de coordenação.',
        'too_high': 'Aparentemente você possui dificuldade quando você arranca a barra do solo.'
    }
};

// Accessory Prescriptions
const prescriptions = {
    'Clean': {
        'too_low': '',
        'too_high': 'Verifique para ter certeza se os seus valores de agachamento estão corretos (Verifique acima para ter certeza). Se estão corretos, você não terá grandes resultados ficando mais forte, você precisa analizar sua técnica de Jerk e investir mais tempo melhorando ela.'
    },
    'Back Squat': {
        'too_low': 'Nós recomendamos que você faça um trabalho para fortalecimento de pernas.',
        'too_high': 'Nós recomendamos que você faça um trabalho para melhorar sua técnica de Clean & Jerk.'
    },
    'Front Squat': {
        'too_low': 'Nós recomendamos que você faça um trabalho para fortalecimento de pernas.',
        'too_high': 'Nós recomendamos que você faça um trabalho para melhorar sua técnica de Clean & Jerk.'
    },
    'Jerk': {
        'too_low': 'Se os seus níveis de squat estão em um nível bom, nós recomendamos que você se dedique a melhorar sua técnica no Jerk. Se seus níveis de squat estão abaixo do adequado, você precisa fazer um trabalho de fortalecimento de pernas.',
        'too_high': 'Assumindo que seus níveis de Squat estejam adequados, recomendamos que você se dedique em melhorar a técnica do Clean.'
    },
    'Power Clean': {
        'too_low': 'Treine para melhorar sua velocidade de explosão/transição.',
        'too_high': 'Se os seu nível de front squat está adequado, se dedique em melhorar sua mobilidade para o Clean & Jerk. Se o seu Front Squat está muito baixo, invista um tempo melhorando a força de pernas.'
    },
    'Clean Blocks Abv Knee': {
        'too_low': 'Você deve investir mais tempo melhorando sua explosão',
        'too_high': 'Você deve investir mais tempo praticando puxadas de clean do chão ou com déficit'
    },
    'Hang Clean Below Knee': {
        'too_low': 'Você deve melhorar sua força de costas, ou buscar um coach para lhe ajudar isoladamente a melhorar os problemas de coordenação.',
        'too_high': 'Você deve investir mais tempo praticando puxadas de clean do chão ou com déficit'
    },
    'Overhead Squat': {
        'too_low': 'Você deve trabalhar força de Overhead e estabilidade.',
        'too_high': 'Parabéns! Não temos nada a sugerir quanto ao seu Overhead Squat.'
    },
    'Power Snatch': {
        'too_low': 'Você precisa pensar sobre ter pernas mais fortes... ou melhorar sua explosão e velocidade quando está embaixo da barra.',
        'too_high': 'Você precisa melhorar sua mobilidade ou buscar um coach para lhe ajudar a melhorar os problemas de coordenação.'
    },
    'Snatch Blocks Abv Knee': {
        'too_low': 'Você deve dedicar mais tempo melhorando sua explosão.',
        'too_high': 'Você deve investir mais tempo praticando puxadas de clean do chão ou com déficit'
    },
    'Hang Snatch Below Knee': {
        'too_low': 'Você deve melhorar sua força de costas, ou buscar um coach para lhe ajudar isoladamente a melhorar os problemas de coordenação.',
        'too_high': 'Você deve investir mais tempo praticando puxadas de clean do chão ou com déficit'
    }
};
export { ranges, accessories, diagnoses, prescriptions };



/** WEBPACK FOOTER **
 ** ./src/data.js
 **/